import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { role, rolesSlice, rolesState } from './RolesSlice'
import { addRoleSlice } from './AddModal/AddModalSlice'

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar'

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader'
import { Confirm } from '../../components/Alerts/Alerts'
import AddModal from './AddModal/AddModal'
import ShowRole from './ShowModal/ShowRole'
import { havePermission } from '../../services/hoc/permissions'
import { useNotification } from '../../services/usenotification'
import { AxiosError } from 'axios'
import { SortTable } from '../../components/Table/SortTable'
import { RowContainer } from '../../components/Table/row_container'

import { useAPI } from '../../services/hoc/useAPI'

const  Roles = () => {

    // Translation
    const t = useTranslation()
   
    const [showRole,setShowRole]=useState({open:false,id:0})
   const keyword_ref=useRef<string|null>(null)
    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { roles: rolesState }) => state.roles)

    // Hooks
  
    const {alertError500}=useNotification()
const ENDPOINTS = useAPI()

    // Search
    const search = (value: string) => {
        keyword_ref.current=Boolean(value)?value:null
        dispatch(rolesSlice.actions.reset())
        fetchData(1,Boolean(value)? 20:8, value);;
    }

    // Fetch Data
    const fetchData =useCallback( (page: number, page_size: number = 8,keyword?:string) => {

        dispatch(rolesSlice.actions.setIsFetching(true))
         keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
        ENDPOINTS.roles().index({ page, page_size, keyword })
            .then((response: any) => {
                let roles: role[] = response.data.data.roles
                dispatch(rolesSlice.actions.setIsFetching(false))
                dispatch(rolesSlice.actions.initializeRoles(roles))
                dispatch(rolesSlice.actions.setHasMore(page < Number(response.data.data.last_page)))
               
                if (!state.isLoaded) dispatch(rolesSlice.actions.setIsLoaded(true))
            })
           .catch((err:AxiosError)=>{
            alertError500(err)
            dispatch(rolesSlice.actions.setIsFetching(false))
           })
    },[ENDPOINTS,dispatch,state.isLoaded]
)
   
    const actions =(role:role)=>
    (
        <div className="show-on-hover">
                    {havePermission("Show Role") ?
                        <i className="icon-info" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                            setShowRole(pre=>({...pre,id:role.id,open:true}))
                        }} /> : ""}
                    {havePermission("Edit Role") ?
                        <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                            e.stopPropagation()
                            dispatch(addRoleSlice.actions.setIsOpen(true))
                            dispatch(addRoleSlice.actions.setEditId(role.id))
                            dispatch(addRoleSlice.actions.set({ name: role.name, permissions: role.permissions?.map(permission => permission.id) }))
                        }} /> : ""}
                    {havePermission("Delete Role") ?
                        <i className="icon-delete" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                            e.stopPropagation()
                            Confirm({
                                message: t("delete_confirmation"),
                                onConfirm: () => remove(role.id)
                            })
                        }} /> : ""}
                </div>
    )
const rows =()=>{
    return state.roles.map((role,index) =>{
        // if (role.id ===1) return null
        return (
            <RowContainer 
            state_length={state.roles.length}
            tr_index={index}
            key={index}
            item_id={role.id.toString()}
            onSelect={toggleSelectedId}
         
              columns={[
                role.name,
                actions(role)
            ]}
            />
        )
    })
}

    // Toggle Selected id
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const toggleSelectedId = (id: number) => {
        if (!havePermission("Delete Role"))
            return
        let index = selectedIds.findIndex(selectedId => selectedId === id)
        if (index !== -1) {
            setSelectedIds(selectedIds.filter(selectedId => selectedId !== id))
        } else
            setSelectedIds([...selectedIds, id])
    }

    // Delete
    const remove = (id?: number) => {

        let ids = id ? [id] : selectedIds.map(x => +x)
        dispatch(rolesSlice.actions.setIsLoading(true))
        ENDPOINTS.roles().delete({ ids })
            .then(() => {
                setSelectedIds([])
                dispatch(rolesSlice.actions.setIsLoading(false))
                dispatch(rolesSlice.actions.deleteRoles(ids))
            })
            .catch((err:AxiosError)=> {
                  dispatch(rolesSlice.actions.setIsLoading(false))
                     alertError500(err)
                     
                  })

    }


    // First fetch
    useEffect(() => {
        if (!state.isFetching)
            fetchData(1)
    }, [])

   //console.log(state.roles)

    return (
        <>
            {state.isLoaded ?
                <>
                    {state.isLoading ? <WhiteboxLoader /> : ""}
                    <TableActionBar
                        title={t("roles")}
                        search={search}
                        showFilter={false}
                        showDelete={selectedIds.length > 0}
                        delete={() => {
                            Confirm({
                                message: t("delete_confirmation"),
                                onConfirm: () => remove()
                            })
                        }}
                        addText={t("add_to_roles")}
                        add={havePermission("Add Role") ? () => dispatch(addRoleSlice.actions.setIsOpen(true)) : undefined}
                    />

                    {/* <DashboardTable
                     
                        header={[t("name"), ""]}
                        body={generateData()}
                        onSelect={toggleSelectedId}
                        hasMore={state.hasMore}
                        loadMore={fetchData}
                        pagesInfo={{page:1,lastPage:1}}
                        setPagesInfo={setPagesInfo}
                    /> */}
                  <SortTable
                    header={[t("name"), ""]}
                   state={state.roles.filter(ele=>ele.id!==1)}
                    onSelect={toggleSelectedId}
                    hasMore={state.hasMore}
                    loadMore={fetchData}
                    pagesInfo={{page:1,lastPage:1}}
                    setPagesInfo={()=>{}}
                  >
                    <>
                    {
                        rows()
                    }
                    </>
                  </SortTable>
                    <AddModal />

                     <ShowRole open={showRole.open}
                      setOpen={()=>setShowRole(pre=>({...pre,open:false}))} 
                     id={showRole.id} />

                  

                </> : <div className="center"><EllipsisLoader /></div>}
        </>
    )

}
export default Roles ;